import { useMemo } from 'react'

import { useTranslation } from 'react-i18next'

import { createCalendarSteps } from 'entities/tour/libs/createCalendarSteps.ts'

import { useGuideTooltip } from 'shared/hooks/use-guide-tooltip.ts'
import { JoyrideTour } from 'shared/ui/joyride-tour'

export const CalendarGuide = () => {
  const { t } = useTranslation()
  const steps = useMemo(() => createCalendarSteps(t), [t])

  const { run, locale, handleCallback } = useGuideTooltip({
    steps,
    cookieKey: 'calendar_guide',
    localeKeys: {
      last: 'tours_block.calendar_guide.last',
    },
  })

  return (
    <JoyrideTour
      steps={steps}
      run={run}
      onCallback={handleCallback}
      locale={locale}
    />
  )
}
